import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ProductDetail.css';
import { staticProducts } from './Products';
import { getProductsByUserId } from '../../api/productApi';
import { getMe } from '../../api/loginAPI';

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchUser() {
      const userData = await getMe();
      setUser(userData);
    }
    fetchUser();
  }, []);

  useEffect(() => {
    if (!user) return;

    const fetchProducts = async () => {
      try {
        const userProducts = await getProductsByUserId(user.Id || user.id);
        const mergedProducts = userProducts.map((userProd) => {
          const matched = staticProducts.find((p) => p.title === userProd.productName);
          return {
            id: userProd.productId,
            title: userProd.productName,
            image: matched?.image || '',
            description: matched?.description || userProd.productDescription,
            features: matched?.features || [],
            useCases: matched?.useCases || [],
            subscriptionDate: userProd.subscriptionDate,
            expiryDate: userProd.expiryDate,
          };
        });

        const selected = mergedProducts.find((p) => p.id === id);
        setProduct(selected || null);
      } catch (err) {
        console.error('Error fetching product details:', err);
      }
    };

    fetchProducts();
  }, [id, user]);

  if (!product) {
    return <p className="loading-text">Loading product details...</p>;
  }

  return (
    <div className="page product-detail-layout">
      <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>

      <h2 className="products-title">{product.title}</h2>

      <div className="product-full-preview">
        <img src={product.image} alt={`${product.title} Full Preview`} />
      </div>

      <p className="product-description">{product.description}</p>

      <div className="product-dates">
        <div><strong>Subscription Date:</strong> {new Date(product.subscriptionDate).toLocaleDateString()}</div>
        <div><strong>Expiry Date:</strong> {new Date(product.expiryDate).toLocaleDateString()}</div>
      </div>

      <div className="feature-section">
        <h4>Key Features</h4>
        <ul className="feature-list">
          {product.features.map((f, idx) => (
            <li key={idx}>{f}</li>
          ))}
        </ul>
      </div>

      <div className="usecase-section">
        <h4>Use Cases</h4>
        <ul className="usecase-list">
          {product.useCases.map((u, idx) => (
            <li key={idx}>{u}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
